<template>
  <div class="p-1">
    <button
      type="button"
      class="bg-gray-200 relative flex flex-shrink-0 h-6 w-12 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
      role="switch"
      aria-checked="false"
      @click="changeLocale($i18n.locale === 'gr' ? 'en' : 'gr')"
    >
      <span
        class="absolute top-0 text-xs font-medium flex items-center justify-center w-6 h-5"
        :class="[
          $i18n.locale === 'gr'
            ? 'opacity-100 ease-in duration-200'
            : 'opacity-0 ease-out duration-100',
        ]"
        >ΕΛ</span
      >
      <span
        class="absolute top-0 right-0 text-xs font-medium flex items-center justify-center w-6 h-5"
        :class="[
          $i18n.locale === 'en'
            ? 'opacity-100 ease-in duration-200'
            : 'opacity-0 ease-out duration-100',
        ]"
        >EN</span
      >
      <span
        class="pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"
        :class="$i18n.locale === 'gr' ? 'translate-x-6' : 'translate-x-0'"
      >
        <span
          class="opacity-100 ease-in duration-200 absolute inset-0 h-full w-full flex items-center justify-center transition-opacity"
          aria-hidden="true"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-3 w-3 text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
            />
          </svg>
        </span>
      </span>
    </button>
  </div>
</template>

<script>
export default {
  methods: {
    changeLocale(locale) {
      this.$i18n.locale = locale;
      window.localStorage.setItem('current-locale', locale);
    },
  },
};
</script>
